import React, { useState } from "react";
import KuikaButton from "../../../../ui-kit/kuika-button/kuika-button";
import KuikaDrawnCheck from "../../../../ui-kit/kuika-drawn-check/kuika-drawn-check";
import { ShowcaseFrame } from "../_layout/showcase-frame";
import { SpecRow } from "../_layout/spec-row";

/** The variables a consumer sets on (or above) the glyph. */
interface IDrawnCheckStyle extends React.CSSProperties {
  "--kuika-drawn-check-delay"?: string;
  "--kuika-drawn-check-color"?: string;
}

const HELD_BACK: IDrawnCheckStyle = { "--kuika-drawn-check-delay": "0.2s" };

const FILLED_BOX: IDrawnCheckStyle = {
  "--kuika-drawn-check-color": "var(--white)",
  display: "inline-flex",
  alignItems: "center",
  justifyContent: "center",
  width: "16px",
  height: "16px",
  borderRadius: "var(--radius-xs)",
  background: "var(--blue-5)"
};

const IN_GREEN: IDrawnCheckStyle = { color: "var(--green-6)", display: "inline-flex" };

export const DrawnCheckStory: React.FC = (): JSX.Element => {
  const [drawKey, setDrawKey] = useState<number>(0);

  return (
    <ShowcaseFrame
      title="Drawn check"
      componentName="KuikaDrawnCheck"
      sourcePath="ui-kit/kuika-drawn-check"
      description="The stroked ✓ every surface that marks something done draws — filter chips, the stepper, the checkbox, an upload row. The kit's one inline SVG: the draw animates a stroke, and a KuikaSvg mask has no stroke. Size, colour, weight and how long the draw is held back all come from the consumer."
    >
      <SpecRow label="Glyphs" caption="check · dash — both one open path of pathLength 24">
        <KuikaDrawnCheck size={16} />
        <KuikaDrawnCheck size={16} glyph="dash" />
      </SpecRow>

      <SpecRow label="Sizes" caption="size={12} · 16 · 24 — or leave it out and size the svg in CSS">
        <KuikaDrawnCheck size={12} />
        <KuikaDrawnCheck size={16} />
        <KuikaDrawnCheck size={24} />
      </SpecRow>

      <SpecRow label="Colour" caption="the text colour by default · --kuika-drawn-check-color on a filled box">
        <span style={IN_GREEN}>
          <KuikaDrawnCheck size={16} />
        </span>
        <span style={FILLED_BOX}>
          <KuikaDrawnCheck size={16} />
        </span>
      </SpecRow>

      <SpecRow label="Draw" caption="draw — the stroke pulls itself on; the second waits --kuika-drawn-check-delay">
        <KuikaButton type="secondary" size="sm" onClick={(): void => setDrawKey(drawKey + 1)}>
          Draw again
        </KuikaButton>
        <KuikaDrawnCheck key={`now-${drawKey}`} size={24} draw />
        <span key={`held-${drawKey}`} style={HELD_BACK}>
          <KuikaDrawnCheck size={24} draw />
        </span>
      </SpecRow>
    </ShowcaseFrame>
  );
};
